export default function ({ $axios, $auth,app,i18n }) {
  $axios.setHeader('X-localization' , i18n.locale)
  $axios.setHeader('withCredentials' , true)
  // $auth.strategies.google.options.redirectUri = `https://www.ilajak.com/${i18n.locale=='ar'?'login':i18n.locale+'/login'}`
  $auth.onRedirect((to,from) => {
    return app.localePath(to)
  })
}
